var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.499756C15.2465 0.499756 19.5 4.75323 19.5 9.99976C19.5 15.2463 15.2465 19.4998 10 19.4998C4.75348 19.4998 0.5 15.2463 0.5 9.99976C0.5 4.75323 4.75348 0.499756 10 0.499756Z",
    fill: "url(#paint0_radial_28179_6593)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54104 7.81821C8.45329 5.95236 11.5538 5.95236 13.4664 7.81821L13.6965 8.04273C13.7922 8.13587 13.7922 8.28728 13.6965 8.38042L12.909 9.14858C12.8611 9.19534 12.7836 9.19534 12.7357 9.14858L12.4192 8.83946C11.0851 7.53767 8.92198 7.53767 7.5879 8.83946L7.24872 9.17048C7.20085 9.21724 7.12329 9.21724 7.07542 9.17048L6.28796 8.40231C6.19222 8.30917 6.19222 8.15777 6.28796 8.06462L6.54104 7.81821ZM15.0948 9.40686L15.7954 10.0904C15.8911 10.1836 15.8911 10.335 15.7954 10.4281L12.6359 13.5108C12.5401 13.6039 12.3854 13.6039 12.2897 13.5108L10.0471 11.3228C10.0234 11.2994 9.98442 11.2994 9.96067 11.3228L7.71815 13.5108C7.62241 13.6039 7.46767 13.6039 7.37192 13.5108L4.21243 10.4281C4.11669 10.335 4.11669 10.1836 4.21243 10.0904L4.91306 9.40686C5.0088 9.31372 5.16354 9.31372 5.25929 9.40686L7.50181 11.5948C7.52556 11.6182 7.56452 11.6182 7.58827 11.5948L9.83079 9.40686C9.92653 9.31372 10.0813 9.31372 10.177 9.40686L12.4195 11.5948C12.4433 11.6182 12.4823 11.6182 12.506 11.5948L14.7485 9.40686C14.8439 9.31335 14.999 9.31335 15.0948 9.40686Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_28179_6593",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.500059 10.0001) scale(19)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.a75593e0a9fd44f77ba4396cbc1fcdce.svg";
export { ForwardRef as ReactComponent };